import * as CONSTANTS from './constants';

export function getInitialState() {
  return {
    src: '',
    dest: '',
    src_vid: '',
    dest_vid: '',
    doj: '',//yyyymmdd
    rDoj: '',
    journeyType: 'onw',
    onwBid: '',
    retBid: '',
    flavour: 'dweb',
    dojObj: '',
    src_name: '',
    dest_name: '',
    busType: [],
    offsetDate: 0,
    others: {},
    footer: [],
    content: "",
    srcState:'',
    destState:'',
    srcLat:'',
    srcLon:'',
    destLat:'',
    destLon:''
  };
}
//TODO:- returning a new object each time with Object.assign instead of direct state manipulation

export default function BusCommon(state = getInitialState(), action) {
  const { type, actionData } = action;

  switch (type) {
    case CONSTANTS.JOURNEY_PARAMS:
      return Object.assign({}, state, {
        ...state,
        src: actionData.src,
        dest: actionData.dest,
        src_vid: actionData.src_vid,
        dest_vid: actionData.dest_vid,
        doj: actionData.doj,
        dojObj: actionData.dojObj,
        rDoj: actionData.rDoj,
        journeyType: actionData.journeyType,
        onwBid: actionData.onwBid,
        retBid: actionData.retBid,
        flavour: actionData.flavour,
        src_name: actionData.src_name,
        dest_name: actionData.dest_name,
        busType: actionData.busType,
        offsetDate: actionData.offsetDate,
        others: actionData.others || state.others,
        srcLat:actionData.srcLat || '',
        srcLon: actionData.srcLon || '',
        destLat:actionData.destLat || '',
        destLon: actionData.destLon || ''
      })
    case CONSTANTS.FOOTER_DATA:
      return Object.assign({}, state, {
        ...state,
        footer: actionData.footer || state.footer
      })
    case CONSTANTS.HOME_PAGE_CONTENT:
      return Object.assign({}, state, {
        ...state,
        content: actionData.content
      })
    case CONSTANTS.INSERT_ROUTE_STATE:
      return Object.assign({}, state, {
        ...state,
        srcState:actionData?.srcState || '',
        destState: actionData?.destState || ''
      })
    default:
      return state;
  }
}

